const Donate = () => {
  return (
    <div>
      <h6>Coming soon ....</h6>
    </div>
  );
};

export default Donate;
